import React, { useEffect } from 'react'
import Routers from './routes'
import { BrowserRouter } from 'react-router-dom'
import { createGlobalStyle } from 'styled-components'
import { initClarity, identifyUser } from './utils/clarity'
import { initPostHog, identifyPostHogUser } from './utils/posthog'
const { REACT_APP_POSTHOG_API_KEY } = process.env;
const { REACT_APP_POSTHOG_HOST } = process.env;
const { ENVIRONMENT } = process.env;
// const { REACT_APP_CLARITY_PROJECT_ID } = process.env

const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
`

const App = ({ token, studentData, getStudentData, SignIn, studentDetails }) => {
  useEffect(() => {
  //   if (REACT_APP_CLARITY_PROJECT_ID != 'null') {
  //     initClarity(REACT_APP_CLARITY_PROJECT_ID)
  //   }
  initPostHog(REACT_APP_POSTHOG_API_KEY, REACT_APP_POSTHOG_HOST);
  // 
  }, [])

  
  useEffect(() => {
    const email = studentDetails?.admin?.email || studentData?.admin?.email
    if (email) {
      identifyUser(email)
      identifyPostHogUser(email, {
        // Environment
        environment: ENVIRONMENT,
        
      })
    }
  }, [studentData, studentDetails])

  return (
    <BrowserRouter>
      <GlobalStyle />
      <Routers token={token} getStudentData={getStudentData} SignIn={SignIn} />
    </BrowserRouter>
  )
}

export default App
